<div class="container">
    <div class="wrapper">
        <div class="header">
            <div class="top-heading">
                <div class="logo text-align-center"></div>
                <br />
                <h6 class="side-title" id="brand-heading" [innerHTML]="translate('label.gb.title.merlin.pcn')"></h6>
            </div>
            <hr class="topper" />
            <hr class="divider" />
        </div>
        <div class="title pb-20">
            <div id="page_title">
                <!-- <div id="main_title_1" class="ssn_page_title"
                    [innerHTML]="translate('label.gb.first_time_registration')">
                </div> -->
                <!-- <span id="subtitle" class="main_sub_title_black" [innerHTML]="translate('msg.lo010.prompt')">
                </span> -->
                <br />
                <span id="subtitle2" class="main_sub_title_black"
                    [innerHTML]="mustBeSigned()">
                </span>
                <br />
            </div>
        </div>
        <!-- T & C window -->
        <div class="termsWindow">
            <div class="pdf-wrapper">
                <ng2-pdfjs-viewer
                    #tcPdfViewer
                    viewerId="tc-pdf-viewer"
                    (onDocumentLoad)="pdfLoaded()"
                ></ng2-pdfjs-viewer>
            </div>
        </div>
        <!-- T & C window end -->
        <br />
        <div class="actionBlock">
            <button mat-raised-button color="primary" class="merlin-button" (click)="declineBtn()" id="declineBtn">
                {{ 'label.gb.i_decline' | translate }}
            </button>
            <div class="agreeArea attrEntry">
                <div class="nameInput">
                    <form class="name-form" (ngSubmit)="acceptBtn()" #nameForm="ngForm">
                       <div class="form-element">
                        <mat-checkbox [(ngModel)]="privacyChecked" [checked]="privacyChecked" name="privacyChecked">
                            <mat-label>* {{'label.gb.privacy_link' | translate}}</mat-label>
                        </mat-checkbox>
                     
                        <mat-label class="privacy_notice_link"> <a href="https://www.cardiovascular.abbott/int/en/policies/merlin-net.html" target="_blank">{{'label.gb.privacy_notice' | translate}}</a></mat-label>
                        <mat-form-field appearance="outline">
                            <mat-label>&nbsp;&nbsp;{{
                                'label.gb.enter_name' | translate
                                }}</mat-label>
                            <input type="text" id="signature" matInput [formControl]="name" (blur)="onBlur($event)" placeholder="{{
                                    'label.gb.enter_name' | translate
                                }}" />
                        </mat-form-field>
                       </div>
                       <!-- {{disableButton}}-{{privacyChecked}} -->
                        <button mat-raised-button color="primary" class="merlin-button" id="acceptBtns" [disabled]="checkDisable()" type="submit">
                            {{ 'label.gb.i_accept' | translate }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
        <!-- <div class="footerSpace"> -->
            <merlin-footer
            class="termsFooter"
            [footerData]="footerData"
            [copyRights]="footerCopyRights"
            [footerClass]="fooMenuClass"
            [copyrightClass]=""
        ></merlin-footer>
        <!-- </div> -->
    </div>
</div>